import styleAf from "./Affiliate.module.scss";
import "./../../../index.scss";
import classNames from "classnames";
import { ReactComponent as ICON } from "../../../assets/images/download.svg";
import { ReactComponent as Arrow } from '../../../assets/images/buysell_arrow.svg';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { AffiliateTime, affiliateTimeDropdowm, ConvertedAffiliateState } from "../../../interfaces";
import { equalsIgnoreCase, formatNumber, roundTo } from "../../../_utils";
import { TYPES } from "../Exchange/Market/constants";
import { ErrorBoundary } from "../../common";

export const AffDetails = ({ details, filter }) => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState<Array<ConvertedAffiliateState>>([]);
  const [activeSort, setActiveSort] = useState([null, null]);

  const checkActiveSort = (name: string, type: TYPES) => {
    if (!activeSort.length || activeSort[0] !== name) return false;
    return activeSort[1] === type;
  }

  const handleSort = (name: string) => {
    let type: TYPES;
    if (!activeSort.length || activeSort[0] !== name) {
      type = TYPES.UP
    } else if (activeSort[1] === TYPES.UP) {
      type = TYPES.DOWN
    } else if (activeSort[1] === TYPES.DOWN) {
      type = TYPES.UP
    }
    setActiveSort([name, type]);
  }

  const convertData = (date: number) => {
    if (equalsIgnoreCase(filter, AffiliateTime.last_year)) {
      const options = { month: 'short', year: 'numeric' };
      return new Date(date).toLocaleDateString('en-US', options);
    } else {
      return new Date(date).toLocaleDateString();
    }
  }

  useEffect(() => {  
    const isAscending = activeSort[1] === TYPES.UP;
    const sortedData = [...tableData];
    sortedData.sort((a,b) => {
      const A = a[activeSort[0]] ?? "";
      const B = b[activeSort[0]] ?? "";
      return isAscending
        ? Number(A) - Number(B)
        : Number(B) - Number(A)
    });
    setTableData(sortedData);
  }, [activeSort]);

  useEffect(() => {
    if (!details || !details.totalRevenue) return;
    const times = details.totalRevenue.map(e => e.time);
    const types = Object.keys(details);
    const data = times.map((time: number) => {
      const el = { date: time };
      types.map((type) => {
        const value = details[type].find(el => el.time === time)?.value;
        el[type] = value;
      });
      return el;
    }) as ConvertedAffiliateState[];
    setTableData(data);
  }, [details]);

  return (
    <div className={styleAf.table_item}>
      <h6 className={styleAf.details_header}>
        <p> 
          { t("affiliates.details_stats") } 
          <span className={styleAf.filter}>{t(affiliateTimeDropdowm[filter])}</span>
        </p>
        <div className={classNames(styleAf.download_cont, styleAf.download_cont_dis)}>
          <button>{ t("affiliates.export_data") } - { filter }.CVS </button>
          <span>0.2 MB <ICON /></span>
        </div>
      </h6>
      
      <div className={styleAf.table_cont}>
      <ErrorBoundary>
        <table className={styleAf.table}>
          <thead className={styleAf.data_head}>
            <tr>
              { Object.entries(titles).map(([key, title], index) => <th key={index}>
                <button className={styleAf.data_head_item} onClick={() => handleSort(key)}>
                  { t(title) }
                  <button
                    className={classNames(styleAf.short_icon, 
                    {[styleAf.active_up]: checkActiveSort(key, TYPES.UP), 
                      [styleAf.active_down]:  checkActiveSort(key, TYPES.DOWN)
                    })}
                  >
                    <Arrow />
                    <Arrow />
                  </button>
                </button>
              </th>) }
            </tr>
          </thead>
          <tbody className={styleAf.data_list}>
            { tableData.map((item, ind) => <DetailsRow key={ind} item={item} date={convertData(item.date)}/>) }
          </tbody>
        </table>
        </ErrorBoundary>
      </div>
    </div>
  )
}

const DetailsRow = ({ item, date }: { item: ConvertedAffiliateState, date: string }) => (
  <tr>
    <td>{date}</td>
    <td>{item.linkClicks}</td>
    <td>{item.registrations}</td>
    <td>{item.firstTimeDepositors}</td>
    <td>${formatNumber(roundTo(item.totalTradingVolume, 2))}</td>
    <td>${formatNumber(roundTo(item.totalFees, 2))}</td>
    <td>${formatNumber(roundTo(item.totalRevenue, 2))}</td>
  </tr>
)

const titles = {
  date: "comman_word.date",
  linkClicks: "affiliates.clicks",
  registrations: "affiliates.registrations",
  firstTimeDepositors: "affiliates.depositors",
  totalTradingVolume: "marketChanges.volume_text",
  totalFees: "pool_table.fees",
  totalRevenue: "affiliates.your_cut"
}